/* eslint-disable spire/export-styles */
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { ConfigurationType } from "@insite/client-framework/Services/ProductServiceV2";
// import ProductAvailability, { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability"; // Poolcorp Custom Code
import React from "react";

/* Poolcorp Custom Code */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import ProductAvailability, { ProductAvailabilityStyles } from "@store/Overrides/Components/ProductAvailability";
import { CustomProductInventoryDto } from "@store/Overrides/Widgets/Cart/CartLines";
import { getStoreSession } from "@store/Store/Context/ContextSelectors";
import getBooleanProperty from "@store/utilities/getBooleanProperty";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState, props: OwnProps) => {
    const session = getStoreSession(state);

    return {
        currentWarehouseName: session.pickUpWarehouse?.name,
    };
};
/* Poolcorp Custom Code */

interface OwnProps {
    isProductDetailsPage?: boolean;
    configurationCompleted?: boolean;
    extendedStyles?: ProductAvailabilityStyles;
    isCondensed?: boolean;
    qtyOrdered?: number;
    clickableComponent?: React.ReactNode;
}

type Props = OwnProps & HasProduct & ReturnType<typeof mapStateToProps>; // Poolcorp Custom Code

const ProductContextAvailability = ({
    productInfo,
    product,
    isProductDetailsPage,
    configurationCompleted,
    extendedStyles,
    // Poolcorp Custom Code
    currentWarehouseName,
    isCondensed = true,
    qtyOrdered,
    clickableComponent,
}: Props) => {
    const { inventory, unitOfMeasure, failedToLoadInventory } = productInfo;

    /* Poolcorp Custom Code */
    const availabilityFallback = inventory ? ({} as any) : undefined; // Poolcorp Custom Code
    const uom = (inventory as CustomProductInventoryDto)?.inventoryWarehousesDtos?.find(uom => uom.unitOfMeasure === productInfo.unitOfMeasure);
    const currentWarehouseInventory =
        uom?.warehouseDtos?.find(o => o.name === currentWarehouseName);
    const availability = currentWarehouseInventory || availabilityFallback;
    const isStockedProp = currentWarehouseInventory?.properties?.isStocked;
    const isStocked = isStockedProp ? getBooleanProperty(isStockedProp) : undefined;
    const isAvailableInWarehouseSequence = uom?.warehouseDtos
        ?.filter(o => o.name !== currentWarehouseName)
        ?.some(o => o.qty > 0);
    /* Poolcorp Custom Code */

    if (
        getIsWebCrawler() ||
        product.isVariantParent ||
        (!!product.configurationType &&
            product.configurationType !== ConfigurationType.None &&
            product.configurationType !== ConfigurationType.Fixed &&
            !configurationCompleted)
    ) {
        return null;
    }

    return (
        <ProductAvailability
            productId={product.id}
            trackInventory={product.trackInventory}
            availability={availability}
            unitOfMeasure={unitOfMeasure}
            isProductDetailsPage={isProductDetailsPage}
            failedToLoadInventory={failedToLoadInventory}
            extendedStyles={extendedStyles}
            // Poolcorp Custom Code
            isStocked={isStocked}
            isCondensed={isCondensed}
            isAvailableInWarehouseSequence={isAvailableInWarehouseSequence}
            qtyAvailable={currentWarehouseInventory?.qty}
            qtyOrdered={qtyOrdered}
            clickableComponent={clickableComponent}
        />
    );
};

export default connect(mapStateToProps)(withProduct(ProductContextAvailability));
